import ChangePasswordPanel from "@/panel/ChangePasswordPanel";

export default function ChangePassword() {
  return (
    <div className="flex justify-center">
      <ChangePasswordPanel />
    </div>
  );
}
